import OlMap from '@m1/ol-map';
import useMountEffect from '@restart/hooks/useMountEffect';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';

import { MAVLINK_MESSAGE_IDS as MESSAGE } from '@/define/messageId';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';

const useCameraFeedback = (robotId) => {
  const cameraFeedback = useRobotTelemetry(robotId, MESSAGE.CAMERA_FEEDBACK);

  useMountEffect(() => {
    return () => {
      OlMap.shoot.remove(robotId);
    };
  });

  useUpdateEffect(() => {
    if (!cameraFeedback) return;

    const { lat, lng } = cameraFeedback;
    OlMap.shoot.add(robotId, { lat, lng });
  }, [cameraFeedback]);
};

export default useCameraFeedback;
